<r1-compass-lib-titled-container title="User">
    <r1-compass-lib-instructions-with-fields-container>
        <r1-compass-lib-instructions headerText="User" instructions>
            Enter the user's email address and provide a username and password.
        </r1-compass-lib-instructions>
        <form formArea [formGroup]="userInfoForm">
            <r1-compass-lib-form-row name="First Name">
                <mat-form-field>
                    <mat-label>First Name</mat-label>
                    <input matInput formControlName="firstName" />
                    @if (userInfoForm.controls.firstName.errors?.['required']) {
                        <mat-error> First Name is required</mat-error>
                    }
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Last Name">
                <mat-form-field>
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName="lastName" />
                    @if (userInfoForm.controls.lastName.errors?.['required']) {
                        <mat-error>Last Name is required</mat-error>
                    }
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Email">
                <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email" />
                    @if (userInfoForm.controls.email.errors?.['required']) {
                        <mat-error>Email is required</mat-error>
                    }
                    @if (
                        userInfoForm.controls.firstName.errors?.['required'] &&
                        !userInfoForm.controls.email.errors?.['required']
                    ) {
                        <mat-error>Invalid email</mat-error>
                    }
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Username">
                <mat-form-field>
                    <mat-label>Username</mat-label>
                    <input matInput formControlName="username" />
                    @if (userInfoForm.controls.username.errors?.['required']) {
                        <mat-error>Username is required</mat-error>
                    }
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Password">
                <div id="password-row">
                    @if (showPasswordLock()) {
                        <button
                            mat-mini-fab
                            aria-label="Edit the password"
                            matTooltip="Edit password"
                            (click)="enablePasswordEditing()"
                            type="button">
                            <mat-icon>lock_open</mat-icon>
                        </button>
                    }
                    <mat-form-field floatLabel="always">
                        <mat-label>Password</mat-label>
                        <input
                            matInput
                            type="password"
                            formControlName="password"
                            autocomplete="false"
                            placeholder="********" />
                        @if (userInfoForm.controls.password.errors?.['required']) {
                            <mat-error>Password is required</mat-error>
                        }
                    </mat-form-field>
                </div>
            </r1-compass-lib-form-row>
        </form>
    </r1-compass-lib-instructions-with-fields-container>

    <div class="add-division-container">
        <div>
            <r1-compass-lib-instructions headerText="Divisions" instructions>
                To add divisions this user can access, click the '+Add' button, select the division from the dropdown,
                and enter the user's Salesforce User ID. To remove divisions, click the
                <fa-icon [icon]="faTrashAlt" /> on the row.
            </r1-compass-lib-instructions>
        </div>
        @for (group of divisionSalesforceUserFormArray.controls; track group; let $arrayIndex = $index) {
            <form [formGroup]="group">
                <r1-compass-lib-field-mapping
                    [index]="$arrayIndex"
                    [totalRequiredRows]="1"
                    [rowOptionButtons]="[{ value: 'delete', display: 'DDD', show: true }]"
                    (clickOption)="deleteSalesforceUserRow($arrayIndex)">
                    <r1-compass-lib-field-row [fieldRowWidth]="5">
                        <r1-compass-lib-field-field [fieldWidth]="2">
                            <mat-form-field>
                                <mat-label>Division</mat-label>
                                <mat-select formControlName="divisionId">
                                    @for (claim of claimsMapped(); track $index) {
                                        <mat-option
                                            (onSelectionChange)="updateSelectedDivision($event, $arrayIndex)"
                                            [disabled]="claim.index === $index && claim.claimed"
                                            [value]="claim.division.id"
                                            >{{ claim.division.divisionCode }} ({{
                                                claim.division.divisionCode
                                            }})</mat-option
                                        >
                                    }
                                </mat-select>
                                @if (group.controls.divisionId.errors?.['nameTaken']) {
                                    <mat-error>Name taken</mat-error>
                                }
                            </mat-form-field>
                        </r1-compass-lib-field-field>

                        <r1-compass-lib-field-field [fieldWidth]="2">
                            <mat-form-field>
                                <mat-label>Salesforce User Id</mat-label>
                                <input matInput formControlName="salesforceUserId" />
                                @if (group.controls.salesforceUserId.errors?.['required']) {
                                    <mat-error>Field is required</mat-error>
                                }
                            </mat-form-field>
                        </r1-compass-lib-field-field>
                    </r1-compass-lib-field-row>
                </r1-compass-lib-field-mapping>
            </form>
        }
        <button mat-raised-button color="primary" (click)="addSalesforceUserRow()" type="button">+Add</button>
    </div>

    <r1-compass-lib-instructions-with-fields-container>
        <r1-compass-lib-instructions headerText="User Role" instructions>
            Select role from the dropdown to grant the user the associated permissions.
        </r1-compass-lib-instructions>
        <form formArea [formGroup]="userInfoForm">
            <r1-compass-lib-form-row name="User Role">
                <mat-form-field>
                    <mat-label>User Roles</mat-label>
                    <mat-select formControlName="iamRole">
                        @for (role of data.roles; track $index) {
                            <mat-option [value]="role.id">{{ role.name }}</mat-option>
                        }
                    </mat-select>
                    @if (userInfoForm.controls.iamRole.errors?.['required']) {
                        <mat-error>A role is required</mat-error>
                    }
                </mat-form-field>
            </r1-compass-lib-form-row>
        </form>
    </r1-compass-lib-instructions-with-fields-container>

    <div id="footer">
        <button mat-stroked-button (click)="dialogRef.close()" type="button">Cancel</button>
        <button
            mat-flat-button
            color="primary"
            (click)="dialogRef.close(userInfoForm.value)"
            [disabled]="userInfoForm.invalid"
            type="submit">
            Save
        </button>
    </div>
</r1-compass-lib-titled-container>
